export default {
  computed: {
    nameRules() {
      return [v => !!v || this.$t(errorEmpty('name'))]
    },
    emailRules() {
      return [
        v => !!v || this.$t(errorEmpty('email')),
        v => /.+@.+\..+/.test(v) || this.$t(errorValid('email')),
      ]
    },
    telRules() {
      return [v => !!v || this.$t(errorEmpty('tel'))]
    },
    msgRules() {
      return [v => !!v || this.$t(errorEmpty('msg'))]
    },
    privacyRules() {
      return [v => !!v || this.$t('contact.error.privacy')]
    },
    brandRules() {
      return [v => !!v || this.$t(errorEmpty('brand'))]
    },
  },
}

const errorEmpty = key => `contact.error.empty.${key}`

const errorValid = key => `contact.error.valid.${key}`
